
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Qualite from '@/extend/classes/Qualite';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeQualite' })

export default class storeQualite extends VuexModule {
  // States
  private reccords: Qualite[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get qualiteLoading (): boolean {
    return this.dataLoading;
  }
  private get qualiteRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get qualiteLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewQualite() {
    return (): Qualite => { 
      return this.getQualite(0, true);
    }
  }

  
  public get getQualite () {
    return (id: number, canCreate = false): Qualite => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Qualite can't be 0")
        return new Qualite();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Qualite();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Qualite.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromQualite(data.reccords[0] as Qualite);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listQualite (): Qualite[] {
    return this.reccords;
  }

  public get listConfigQualite (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mQualiteRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mQualiteClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mQualiteLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mQualiteLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Qualite.fromJson(reccord as Qualite));
    })
    Qualite.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mQualiteConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mQualiteCreated (obj: Qualite): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareQualite(obj)) {
          api.fromQualite(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareQualite(obj)) {
            api.fromQualite(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mQualiteUpdated (obj: Qualite): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareQualite(obj)) {
          api.fromQualite(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mQualiteDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerQualite (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.qualiteRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerQualite(this.qualiteCreated, this.qualiteUpdated, this.qualiteDeleted);
          this.mQualiteRegistered();
        } else {
          setTimeout(() => resolve(this.registerQualite(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.qualiteLoading && !this.qualiteLoaded) {
          this.mQualiteLoading(true);
          return Qualite.list(filter)
            .then((data: ListData) => {
              this.mQualiteLoaded(data);
              this.mQualiteLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredQualite (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.qualiteLoading) {
        this.mQualiteLoading(true);
        return Qualite.list(filter)
          .then((data: ListData) => {
            this.mQualiteLoaded(data);
            this.mQualiteLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createQualite (obj: Qualite): Promise<Qualite> {
    return new Promise((resolve, reject) => {
      return Qualite.fromJson(obj).createForStoreQualite()
        .then((reccords) => {
          this.mQualiteCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateQualite (obj: Qualite): Promise<Qualite> {
    return new Promise((resolve, reject) => {
      return Qualite.fromJson(obj).updateForStoreQualite()
        .then((reccords) => {
          this.mQualiteUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteQualite (obj: Qualite): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Qualite.fromJson(obj).deleteForStoreQualite()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mQualiteDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private qualiteCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mQualiteConfigUpdated(config)
    const obj = objConfig.obj as Qualite;
    this.mQualiteCreated(Qualite.fromJson(obj));
  }

  @Action
  private qualiteUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mQualiteConfigUpdated(config)
    const obj = objConfig.obj as Qualite;
    this.mQualiteUpdated(Qualite.fromJson(obj));
  }

  @Action
  private qualiteDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Qualite;
    this.mQualiteDeleted(obj.id);
  }
}
